import React from 'react';
import '../../styles/instructions.css';

const Instructions = (props) => {
    const { startARMap, areInstructionsRead } = props;

    return (
        !areInstructionsRead ?
        <div className="instructions">
            <div className="content">
                <h4>Welcome to Salesforce Tower</h4>
                <p>"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce non risus vitae lectus varius molestie in eget est. Pellentesque nec varius felis. Vestibulum rhoncus, nunc et mattis iaculis, tellus est volutpat justo"</p>
                <p>"Nunc faucibus metus vel fringilla pulvinar. Pellentesque ullamcorper porttitor dui, nec pharetra nisl pretium a. Integer quis euismod velit. In maximus velit venenatis, egestas sapien vitae, efficitur lorem.",</p>
                <button onClick={startARMap}>Start</button>
            </div>
        </div>
        : null
    )
}

export default Instructions;
